/* eslint-disable no-use-before-define */
import moment from 'moment';
import { getTimeZones } from '@vvo/tzdb';

export function formatStartDate(startDate, displayYear = false) {
  if (!startDate || !startDate.trim().length) {
    return '';
  }
  const date = new Date(startDate);
  return `${date.getDate()} ${date.toLocaleString('en-US', { month: 'short' })}${displayYear ? ` ${date.getFullYear()}` : ''}`;
}

export function formatStartDateWithTime(startDate) {
  if (!startDate || !startDate.trim().length) {
    return '';
  }
  return moment(startDate).format('DD MMM, HH:mm');
}

export function formatStartDateWithTimeAndYear(startDate) {
  if (!startDate || !startDate.trim().length) {
    return '';
  }
  if (moment(startDate).year() === moment().year()) {
    return formatStartDateWithTime(startDate);
  }

  return moment(startDate).format('DD MMM YYYY, HH:mm');
}

export function formatEndDate(endDate) {
  if (!endDate || !endDate.trim().length) {
    return '';
  }
  const date = new Date(endDate);
  return `${date.getDate()} ${date.toLocaleString('en-US', { month: 'short' })} ${date.getFullYear()}`;
}
export function calculateDuration(startTime, endTime) {
  const start = new Date(startTime);
  const end = new Date(endTime);

  const timeDifference = end - start;
  const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

  if (days > 0) {
    return `${days}d ${formatTime(hours)}h ${formatTime(minutes)}m`;
  } if (hours > 0) {
    return `${formatTime(hours)}h ${formatTime(minutes)}m`;
  }
  return `${formatTime(minutes)}m`;
}

function formatTime(value) {
  return value < 10 ? `0${value}` : value;
}

export function formatDateToShort(date) {
  return date ? moment.utc(date).format('D MMM, yyyy') : '';
}

export const formatSingleDateToDatepicker = (date = '', format = 'MMMM, yyyy') => (date ? moment(date).format(format) : '');

export const formatRangeDateToDatepicker = ([startDate = '', endDate], type) => {
  const dateFormat = 'DD MMM YYYY';
  if (!startDate) return '';
  if (type === 'daterange') {
    if (moment(startDate).date() !== moment(endDate).date() || moment(startDate).month() !== moment(endDate).month() || moment(startDate).year() !== moment(endDate).year()) {
      return `${formatSingleDateToDatepicker(startDate, dateFormat)} - ${formatSingleDateToDatepicker(endDate, dateFormat)}`;
    }
    return `${formatSingleDateToDatepicker(startDate, dateFormat)}`;
  }

  if (type === 'monthrange') {
    if (moment(startDate).month() !== moment(endDate).month() || moment(startDate).year() !== moment(endDate).year()) {
      return `${formatSingleDateToDatepicker(startDate)} - ${formatSingleDateToDatepicker(endDate)}`;
    }
    return `${formatSingleDateToDatepicker(startDate)}`;
  }

  return `${formatSingleDateToDatepicker(startDate, dateFormat)}`;
};

export const formatTZOffset = offset => {
  const negative = offset < 0;

  const hours = Math.floor(Math.abs(offset) / 60);
  const minutes = Math.abs(offset) % 60;

  return `${negative ? '-' : '+'}${String(hours).padStart(2, 0)}:${String(minutes).padStart(2, 0)}`;
};

const getTimezones = () => getTimeZones();

export const getGroupedTimezonesList = () => {
  const timezones = self.getTimezones();
  const tzByOffset = {};

  timezones.forEach(tz => {
    const offset = tz.currentTimeOffsetInMinutes;
    tzByOffset[offset] = tzByOffset[offset] || {};
    tzByOffset[offset].id = tz.name;
    tzByOffset[offset][tz.alternativeName] = tzByOffset[offset][tz.alternativeName]
      ? tzByOffset[offset][tz.alternativeName] + tz.mainCities.length
      : tz.mainCities.length;
  });

  const groupedTimezones = Object.keys(tzByOffset)
    .map(offset => {
      const mostPopularTZ = Object.keys(tzByOffset[offset]).reduce(
        (acc, item) => (tzByOffset[offset][acc] > tzByOffset[offset][item] ? acc : item),
        '',
      );

      return {
        offset,
        formattedOffset: formatTZOffset(offset),
        name: mostPopularTZ,
        id: tzByOffset[offset].id,
      };
    })
    .sort((a, b) => a.offset - b.offset);

  return groupedTimezones;
};

// Unit-tests purposes only
export const self = {
  getTimezones,
};
